function runIfElementExist(script, identifier) {
  /* 
      script - function to run
      identifire - the element wich must be on page to run function
       */
  $(function () {
    if ($(identifier).length) {
      script();
    }
  });
}
